var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAuthImgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 501,
    viewBox: "0 0 338 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M296.795 115.198L381.572 29.6749V-13.5967L296.795 71.3478V115.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M255.062 73.4155L296.799 115.2V71.3497L255.062 28.665V73.4155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M296.876 31.951L339.836 -11.788V-55L296.795 -12.2813L296.876 31.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M212.009 243.684L296.786 158.16V114.889L212.009 199.833V243.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M170.276 201.9L212.013 243.684V199.834L170.276 157.149V201.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M212.091 160.435L255.05 116.696V73.4844L212.009 116.203L212.091 160.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M296.799 201.898L338.536 243.683V199.833L296.799 157.148V201.898Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M126.506 372.513L211.283 286.989V243.718L126.506 328.662V372.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M84.7734 330.729L126.51 372.513V328.663L84.7734 285.979V330.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M126.588 289.265L169.547 245.526V202.314L126.506 245.033L126.588 289.265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M41.7329 500.999L126.51 415.476V372.204L41.7329 457.149V500.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 459.215L41.7367 500.999V457.15L0 414.465V459.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M41.8144 417.75L84.7739 374.011V330.799L41.7329 373.518L41.8144 417.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M253.014 372.512L337.79 286.988V243.717L253.014 328.661V372.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M211.281 330.728L253.017 372.512V328.662L211.281 285.978V330.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M253.095 289.264L296.055 245.525V202.313L253.014 245.032L253.095 289.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M168.253 500.995L253.03 415.471V372.2L168.253 457.144V500.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M126.52 459.211L168.257 500.995V457.145L126.52 414.46V459.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M168.334 417.745L211.294 374.006V330.794L168.253 373.513L168.334 417.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M337.791 330.728L379.527 372.512V328.662L337.791 285.978V330.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M294.761 500.999L379.537 415.476V372.204L294.761 457.149V500.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M253.028 459.215L294.764 500.999V457.15L253.028 414.465V459.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M294.842 417.75L337.802 374.011V330.799L294.761 373.518L294.842 417.75Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthImgMobile);
export default __webpack_public_path__ + "static/media/Auth_img_mobile.6893a9a375ec8bf351ac02e1736fdc43.svg";
export { ForwardRef as ReactComponent };